const noop = (): void => undefined

// The Echo connection is a singleton, so one listener tracks it for every composable instance and the identity reset.
class NotificationsConnectionTracking {
  #stop = noop
  #epoch = 0

  // Subscriptions captured under an older epoch were superseded or torn down.
  epoch(): number {
    return this.#epoch
  }

  isCurrent(epoch: number): boolean {
    return this.#epoch === epoch
  }

  invalidate(): void {
    this.#epoch += 1
  }

  start(register: () => () => void): void {
    this.stop()
    this.#stop = register()
  }

  stop(): void {
    this.#stop()
    this.#stop = noop
  }
}

export const notificationsConnectionTracking = new NotificationsConnectionTracking()
